import "../sass/_index.scss";

import Component_OffsetScroll from "./components/offsetScroll";
import Component_ScrollHandler from "./components/scrollHandler";
import Component_toggleLabelPosition from "./components/toggleLabelPosition";
import Component_UpdateDynamicAnchors from "./components/updateDynamicAnchors";

//import Component_ComtactPopup from "./components/contactPopup";

//Component_ComtactPopup();
Component_ScrollHandler();
Component_toggleLabelPosition();
Component_UpdateDynamicAnchors();
Component_OffsetScroll();
